export const AppsData = [
    {
        title: 'Quoted',
        subtitle: 'Express SQL self-hosted nginx',
        description: 'A quote feed of over about 2000 quotes.',
        image: '/assets/projects/quoted_watsonised_me.webp',
        link: 'https://quoted.watsonised.me',
        github: 'https://github.com/Mark33Mark/quoted',
    },
    {
        title: 'Watson Property',
        subtitle: 'React Redux JWT Authentication MongoDB TanstackQuery',
        description: 'Property management program, converts spreadsheet to JSON.',
        image: '/assets/projects/watson-property_netlify_app.webp',
        link: 'https://watson-property.netlify.app',
        github: 'https://github.com/Mark33Mark/tech-yes',
    },
    {
        title: 'Watson SSR',
        subtitle: 'SolidJS SSR',
        description: 'My own SSR template, instead of Next or SolidStart.',
        image: '/assets/projects/watsonised-ssr_netlify_app.webp',
        link: 'https://watsonised-ssr.netlify.app',
        github: '#',
    },
    {
        title: 'Doggy Wiki',
        subtitle: 'React Netlify',
        description: 'Simple app for reviewing cat breeds to determine suitability for you.',
        image: '/assets/projects/doggy-wiki_netlify_app.webp',
        link: 'https://doggy-wiki_netlify_app',
        github: 'https://github.com/Mark33Mark/tech-yes',
    },
    {
        title: 'Kitty Wiki',
        subtitle: 'React Netlify',
        description: 'Simple app for reviewing cat breeds to determine suitability for you.',
        image: '/assets/projects/kitty-wiki_netlify_app.webp',
        link: 'https://kitty-wiki.netlify.app',
        github: 'https://github.com/Mark33Mark/catwiki_serverless',
    },
    {
        title: 'Codeserver',
        subtitle: 'Docker nginx yaml',
        description: 'Self hosted vs-codeserver containerised using my Dockerfile.',
        image: '/assets/projects/codeserver_watsonised_me.webp',
        link: 'https://codeserver.watsonised.me',
    },
        {
        title: 'Flickering',
        subtitle: 'MERN GraphJS Apollo',
        description: 'A tracker for your emotions / mood.',
        image: '/assets/projects/flickering_notesPage.webp',
        link: '#',
        github: 'https://github.com/Mark33Mark/flickering',
    },
    // {
    //     title: 'J.A.T.E.',
    //     subtitle: 'PWA IndexedDB Heroku ',
    //     description: 'An installable PWA for script editing.',
    //     image: '/assets/projects/JATE_screengrab.webp',
    //     link: '#',
    //     github: 'https://github.com/Mark33Mark/PWA_text_editor',
    // },
    // {
    //     title: 'Tech-Yes',
    //     subtitle: 'mySQL Sequelize BCrypt Heroku',
    //     description: 'A blog site with user authentication.',
    //     image: '/assets/projects/tech_yes_screengrab.webp',
    //     link: '#',
    //     github: 'https://github.com/Mark33Mark/tech-yes',
    // },
    // {
    //     title: 'Weather Dash',
    //     subtitle: 'Open-Weather API LocalStorage',
    //     description: 'Remembers multiple locations.',
    //     image: '/assets/projects/weather_dash.webp',
    //     link: 'https://sun.watsonised.me',
    //     github: 'https://github.com/Mark33Mark/weather-dashboard',
    // },
    // {
    //     title: 'Lettuce-Eat',
    //     subtitle: 'API CSS JavaScript',
    //     description: 'A recipe generating application.',
    //     image: '/assets/projects/lettuce_eat.webp',
    //     link: '#',
    //     github: 'https://github.com/Mark33Mark/recipe-generator',
    // },
    // {
    //     title: 'Quiz',
    //     subtitle: 'JavaScript CSS',
    //     description: 'A fun template for hosting online quizzes.',
    //     image: '/assets/projects/code_quiz.webp',
    //     link: 'https://quiz.watsonised.me',
    //     github: 'https://github.com/Mark33Mark/code-quiz_webAPI',
    // },
    // {
    //   title: "Scheduler",
    //   subtitle: "JavaScript CSS LocalStorage",
    //   description:"Simple but effective daily scheduler.",
    //   image: "/assets/projects/workday_scheduler.jpg",
    //   link: "https://task.watsonised.me",
    //   github: "https://github.com/Mark33Mark/workday-scheduler",
    // },
    // {
    //     title: 'Flick3d',
    //     subtitle: 'tech: SQL GSAP Sequelize',
    //     description: 'Lookup next 12-months of movie release dates.',
    //     image: '/assets/projects/flicked_landing.webp',
    //     link: '#',
    //     github: 'https://github.com/Mark33Mark/movie-scheduler',
    // },
];

export const Skills = [
    'AI',
    "API's",
    'AWS',
    'C',
    'CSS/Sass',
    'Docker',
    'Git',
    'JavaScript',
    'MongoDB',
    'Mongoose',
    'Netlify',
    'Node',
    'NoSQL',
    'PHP',
    'Python',
    'React',
    'SolidJS',
    'SQL',
    'Storybook',
];
